<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M15 38h-2a1 1 0 000 2h2a1 1 0 000-2z"/><path d="M41.7 27H24V12a2 2 0 00-2-2H6a2 2 0 00-2 2v30a2 2 0 002 2h35.7a2.09 2.09 0 002.3-1.79V28.79A2.09 2.09 0 0041.7 27zM21 13v22H7V13zM7 41v-4h14v4zm34 0H24V30h17zM27.24 6.72a10 10 0 019.46 9.43l-.92-.93a1 1 0 00-1.42 1.41l2.8 2.81a1 1 0 00.71.29 1 1 0 00.71-.29l2.8-2.8a1 1 0 000-1.41 1 1 0 00-1.42 0L38.7 16.5A12 12 0 0027.35 4.72a1 1 0 00-1.05 1 1 1 0 00.94 1z"/></svg>